module.exports = require("./rm-CH.js");